import { auth } from '../../../firebase';
import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { v4 as uuidv4 } from 'uuid';

// payload is a partial patch — a flat { [toolName]: boolean } map holding only
// the rows that changed. Anything omitted is left untouched by the backend.
const updateSensitiveTools = (payload, callback, errCb) => {
  return async (dispatch) => {
    dispatch({ type: 'UPDATING_SENSITIVE_TOOLS' });
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.put(`/ads/sensitive-tools`, payload, {
            params: {
              'request-id': reqId,
            },
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          if (response.status === 200) {
            await dispatch({
              type: 'UPDATING_SENSITIVE_TOOLS_DONE',
            });
            if (typeof callback === 'function') {
              callback(response?.data);
            }
          } else {
            dispatch({
              type: 'UPDATING_SENSITIVE_TOOLS_FAILED',
              payload: `Failed to update sensitive tools`,
            });
            if (typeof errCb === 'function') {
              errCb(`Failed to update sensitive tools`);
            }
          }
        } catch (e) {
          dispatch({
            type: 'UPDATING_SENSITIVE_TOOLS_FAILED',
            payload: `Failed to update sensitive tools`,
          });
          if (typeof errCb === 'function') {
            errCb(
              e?.response?.status === 401
                ? `You need the ROLE_ADMIN role to change sensitive tools`
                : e?.response?.data?.message ||
                    `Failed to update sensitive tools`,
            );
          }
        }
        unsubscribe();
      });
    } catch (e) {
      console.log(e);
      dispatch({
        type: 'UPDATING_SENSITIVE_TOOLS_FAILED',
        payload: `Failed to update sensitive tools`,
      });
      if (typeof errCb === 'function') {
        errCb(`Failed to update sensitive tools`);
      }
    }
  };
};

export default updateSensitiveTools;
